import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Button, ButtonLabel } from "@similarweb/ui-components";

import { ProModal } from "../../Modals/src/ProModal";
import { useTranslation } from "../../WithTranslation/src/I18n";

import { Footer, ModalSubtitle, ModalTitle, TitleContainer } from "./SelectWorkspaceTrialModal";

interface IThankYouModalProps {
    isOpen: boolean;
    onCloseClick: () => void;
    title: string;
    ThankUModalImage?: any;
    hasGaToken?: boolean;
    privacyStatus?: string;
    gaButtonLabel?: string;
    onGAButtonClick?: () => void;
    subtitle?: string;
    closeLabel: string;

    /**
     * Disables GA. this property comes from a special claim called "NoGA"
     */
    isGADisabled?: boolean;
}
const modalStyle: any = {
    customStyles: {
        content: {
            boxSizing: "content-box",
            width: "500px",
            padding: "16px",
        },
    },
};
const StyledModalTitle = styled(ModalTitle)`
    font-size: 20px;
    margin-bottom: 24px;
    line-height: 24px;
`;

const StyledTitleContainer = styled(TitleContainer)`
    justify-content: center;
    margin-top: 30px;
`;

const StyledFooter = styled(Footer)`
    margin: 0px;
`;
const CustomButton = styled.span`
    align-items: center;
    display: flex;
    &:hover {
        cursor: pointer;
    }
    margin-right: 20px;
`;
const Label = styled.span`
    text-align: center;
    font-size: 0.875rem;
    font-weight: bold;
    text-transform: uppercase;
    margin-left: 4px;
    color: ${colorsPalettes.blue["400"]};
    &:hover {
        color: ${colorsPalettes.blue["500"]};
    }
`;

const StyledModalSubtitle = styled(ModalSubtitle)`
    max-width: 70%;
`;

export const ThankYouModal = ({
    isOpen,
    onCloseClick,
    title,
    subtitle,
    closeLabel,
    ThankUModalImage,
    gaButtonLabel,
    onGAButtonClick,
    hasGaToken,
    privacyStatus,
    isGADisabled,
}: IThankYouModalProps) => {
    const translate = useTranslation();

    return (
        <ProModal
            isOpen={isOpen}
            onCloseClick={onCloseClick}
            {...modalStyle}
        >
            <StyledTitleContainer>
                <StyledModalTitle>{translate(title)}</StyledModalTitle>
            </StyledTitleContainer>
            {subtitle ? <StyledModalSubtitle>{translate(subtitle)}</StyledModalSubtitle> : null}
            {ThankUModalImage ? <ThankUModalImage /> : null}
            <StyledFooter>
                {gaButtonLabel && privacyStatus !== "Public" && !isGADisabled && !hasGaToken ? (
                    <CustomButton onClick={onGAButtonClick}>
                        <SWReactIcons
                            size="xs"
                            iconName="ga-icon"
                        />
                        <Label>{translate(gaButtonLabel)}</Label>
                    </CustomButton>
                ) : null}
                <Button
                    onClick={onCloseClick}
                    type="primary"
                >
                    <ButtonLabel>{translate(closeLabel)}</ButtonLabel>
                </Button>
            </StyledFooter>
        </ProModal>
    );
};
